<template>
  <div class="plan-item-4">
    <div class="title">计划执行基本原则</div>
    <div class="principle-container">
      <div class="principle-item">
        <div class="principle-flag">
          <div class="flag-dot"></div>
          <div class="flag-dash"></div>
        </div>
        <div class="principle-item-title"
          >01 不挨饿 不节食 拒绝“疼痛式”减脂</div
        >
        <img
          class="principle-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/35e3a52edaec78ac1301560cd48e8936.png"
          alt=""
        />
      </div>
      <div class="principle-item">
        <div class="principle-flag">
          <div class="flag-dot"></div>
          <div class="flag-dash"></div>
        </div>
        <div class="principle-item-title">02 精准营养 基于独立个体定制</div>
        <div class="method-list">
          <div
            class="method-item"
            v-for="(item, index) in data.specify_txt"
            :key="index"
          >
            <div class="m-item-title">{{ item[0] }}</div>
            <div class="m-item-icon iconfont icon-cha"></div>
            <div class="m-item-text">{{ item[1] }}</div>
          </div>
        </div>
      </div>
      <div class="principle-item">
        <div class="principle-flag">
          <div class="flag-dot"></div>
          <div class="flag-dash"></div>
        </div>
        <div class="principle-item-title">03 不止减重 兼顾你的多维营养需求</div>
        <div class="principle-tag-list">
          <img
            class="tag-image"
            v-for="(item, index) in imageList"
            :key="index"
            :src="item"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      imageList: [
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cab3c586eac106cfbf76b7ab594bc0e5.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/49d396e23f6ac087dde75bf996b876a5.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c1619f3a871f0ac9305df0186189feae.png'
      ]
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.plan-item-4 {
  .title {
    position: relative;
    color: rgba(48, 48, 56, 0.7);
    padding-left: 10px;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 11px;
  }

  .title::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 4px;
    height: 20px;
    background-color: rgba(48, 48, 56, 0.3);
    transform: translate(0%, -50%);
  }

  .principle-container {
    padding: 18px 14px 26px;
    background: #ffffff;
    border-radius: 6px;

    .principle-item {
      padding-left: 18px;
      padding-bottom: 25px;
      position: relative;

      .principle-flag {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        transform: translateY(4px);

        .flag-dot {
          width: 13px;
          height: 13px;
          box-sizing: border-box;
          background: #ffffff;
          border: 3px solid #e0e0e0;
          border-radius: 50%;
        }

        .flag-dash {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          width: 1px;
          background-image: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.3) 0%,
            rgba(0, 0, 0, 0.3) 50%,
            rgba(0, 0, 0, 0) 51%,
            rgba(0, 0, 0, 0) 100%
          );
          background-size: 1px 2px;
          background-repeat: repeat-y;
        }
      }

      .principle-item-title {
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        color: #303038;
        margin-bottom: 10px;
      }

      .principle-image {
        width: 100%;
      }

      .principle-tag-list {
        .tag-image {
          width: 100%;
          height: 70px;
          margin-bottom: 6px;
        }

        .tag-image:last-child {
          margin-bottom: 0px;
        }
      }

      .method-list {
        .method-item {
          display: flex;
          align-items: center;
          margin-bottom: 6px;

          .m-item-title {
            width: 80px;
            padding: 0px 5px;
            height: 36px;
            background: rgb(255, 241, 219);
            border-radius: 4px;
            font-weight: bold;
            font-size: 12px;
            line-height: 36px;
            color: rgb(255, 161, 19);
            text-align: center;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .m-item-icon {
            width: 21px;
            height: 21px;
            margin: 0px 4px;
            color: #979797;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .m-item-text {
            flex: 1;
            flex-shrink: 0;
            height: 36px;
            background: rgb(228, 247, 238);
            border-radius: 4px;
            color: rgba(48, 48, 56, 0.7);
            padding: 0px 10px;
            font-weight: bold;
            font-size: 12px;
            line-height: 36px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }

    .principle-item:last-child {
      padding-bottom: 0px;

      .principle-flag {
        transform: translateY(0);
      }
    }
  }
}
</style>
